import './fluck-audio.js'
import lightGallery from 'lightgallery';

/* Nav
------------- */

// on initialisation
const body = document.querySelector("body");
const navToggle = document.querySelector('#site-nav-toggle-link');
const introText = document.querySelector('#site__intro');
const siteOverlay = document.querySelector('#site__overlay');
let scrollPosition = window.scrollY;

function isHome() {
  if( body.classList.contains("home") ) {
    return true;
  } else {
    return false;
  }
}

// set initial state
body.classList.add("site-nav--closed");
navToggle.addEventListener( 'click', toggleNav );

if( isHome() && scrollPosition < 80 ) {
  // use site intro text instead of real nav
  body.classList.add("site-nav--intro");
}

// when nav is toggled
function toggleNav() {

  // nav is being opened...
  if ( body.classList.contains("site-nav--closed") ) {

    let scrollPosition = window.scrollY;

    body.classList.remove("site-nav--closed");

    if( isHome() && scrollPosition > 80 ) {
      introText.style.zIndex = "0";
    }

    // show real nav if intro text is cut off to far
    if( !isHome() || isHome() && scrollPosition > 80 ) {

      // use real nav instead of site intro

      body.classList.toggle("site-nav--proper");

      // when on Home and nav is not cloned yet
      if ( isHome() && !document.querySelector('#site__nav') ) {

        // clone intro into overlay as real nav
        const clonedIntroText = introText.cloneNode(true);
        clonedIntroText.id = 'site__nav';
        clonedIntroText.classList.add('site__nav');
        siteOverlay.appendChild(clonedIntroText);

      } else if ( !isHome() ) {

        const siteIntro = document.querySelector('.site__intro');
        siteIntro.classList.add('site__nav');

      }

    }

    body.classList.add("site-nav--opening");

    // nav has opened...
    setTimeout(function(){
      body.classList.add("site-nav--opened");
      body.classList.remove("site-nav--opening");
    }, 301);

  } else if (
    body.classList.contains("site-nav--opened") ||
    body.classList.contains("site-nav--opening")
  ) {

    // nav will be closed...

    let scrollPosition = window.scrollY;



    function closeMenu( navDelay = 0, overlayDelay = 0, removalDelay = 0 ) {

      body.classList.add("site-nav--closing");
      body.classList.remove("site-nav--opened");

      setTimeout(function() {
        body.classList.add("site-nav--hiding");
        body.classList.remove("site-nav--closing");
      }, 350 );

      // hide the nav a way a little later for nicer transition
      setTimeout(function() {
        body.classList.add("site-nav--closed");
        body.classList.remove("site-nav--hiding");
        introText.style.zIndex = "5";
      }, 650 );

      setTimeout(function() {
        let siteNav = document.querySelector('#site__nav');
        if ( siteNav ) {
          siteNav.remove();
        }
      }, 1000);

    }

    // if intro text is used for nav...
    if( isHome() && scrollPosition < 80 ) {

      // fade out immediately
      closeMenu( 350, 650, 950 );

    } else {

      // ...otherwise close nav with a slight delay
      closeMenu( 350, 650, 950 );

    }

  }
}

/// check url anchor
const urlParts = document.URL.split('#')
if(urlParts.length > 1) {
  if(urlParts[1] === 'main-nav') {
    toggleNav()
  }
}


/* Lightbox
------------- */
const lgSettings = {
  licenseKey: '7782866B-C63F4A38-85BE5937-C5D74DAE',
  speed: 500,
  download: false,
  selector: 'a',
  mobileSettings: {
    controls: true,
    showCloseIcon: true,
  }
};

document.querySelectorAll('.post__content > .wp-block-gallery').forEach(function(galleryEl) {

    galleryEl.querySelectorAll('.wp-block-image').forEach(function(imageEl) {
      const figcaptionEl = imageEl.querySelector('figcaption');
      if(figcaptionEl) {
        const aEl = imageEl.querySelector('a');
        if(aEl) {
          aEl.setAttribute('data-sub-html', figcaptionEl.innerHTML);
        }
        figcaptionEl.style.display = 'none';
      }
    })

    const gallery = lightGallery(galleryEl, lgSettings);

    // Display only the first 5 images
    // 1. hide the rest
    // 2. add a button to show the rest
    const galleryItems = galleryEl.querySelectorAll('.wp-block-image');
    const galleryItemsCount = galleryItems.length;
    galleryEl.classList.add("gallery--" + galleryItemsCount + "-items");

    // 1. hide the items after the 5th
    for (let i = 5; i < galleryItemsCount; i++) {
      galleryItems[i].classList.add("gallery__item--hidden");
    }

    // 2. add a button to show the rest
    if(galleryItemsCount > 5) {
      console.log('document.documentElement.lang === "en"', document.documentElement.lang)
      const showMoreButton = document.createElement("button");
      showMoreButton.classList.add("gallery__show-more", "playful-text-link");
      showMoreButton.innerHTML = document.documentElement.lang == "de-DE" ? "Bildergalerie" : 'Image Gallery';
      galleryEl.appendChild(showMoreButton);
      showMoreButton.addEventListener( 'click', () => {
        gallery.openGallery()
      } );
    }
})

document.querySelectorAll('.post__content > .wp-block-image').forEach(function(imageEl) {
    const aEl = imageEl.querySelector('a');
    if(aEl) {
      const figcaptionEl = imageEl.querySelector('figcaption');
      if(figcaptionEl) {
        const aEl = imageEl.querySelector('a');
        aEl.setAttribute('data-sub-html', figcaptionEl.innerHTML);
      }

      lgSettings.controle = false
      lightGallery(imageEl, lgSettings);
    }
})

/* const image = document.querySelector('.post__content img');
console.log(image);
image.addEventListener( 'click', ChangeImages );

function ChangeImages() {
  setTimeout(function() {
  let swipeboxClose = document.querySelector('#swipebox-close');
  let swipeboxPrev = document.querySelector('#swipebox-prev');
  let swipeboxNext = document.querySelector('#swipebox-next');
  }, 300 );

  swipeboxClose.src='https://img.pngio.com/kitten-dragon-li-pet-dog-animal-cats-cats-png-900_900.jpg';
} */



/* Plyr
------------- */

// Change "{}" to your options:
// https://github.com/sampotts/plyr/#options
/* const player = new Plyr('audio', {
  controls: ['play', 'progress', 'current-time']
});

// Expose player so it can be used from the console
window.player = player; */


/* Fluck Audio Player Block
------------- */




